import React from 'react';
import { tv } from 'tailwind-variants';
import cn from '@/utils/cn';

// AIDEV-NOTE: The SPA's status/label pill, shaped like ui/Pill: fully round, bold text in the
// tone's colour over a light tint of the same colour. The tint is color-mix of the text token
// (the saved-flash animation in _sysadmin_spa.scss does the same), so one pair of tokens per tone
// serves both themes without a separate fill token. Each class is written out in full because
// Tailwind only generates classes it can read verbatim from the source.
const pillVariants = tv({
  base: [
    'tw-inline-flex tw-w-fit tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-full',
    'tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold tw-leading-4',
  ],
  defaultVariants: { tone: 'neutral' },
  variants: {
    tone: {
      accent: 'tw-bg-spa-accent-bg tw-text-spa-accent-text',
      error: 'tw-bg-[color:color-mix(in_srgb,var(--spa-text-error)_12%,transparent)] tw-text-spa-error',
      info: 'tw-bg-[color:color-mix(in_srgb,var(--spa-text-info)_12%,transparent)] tw-text-spa-info',
      neutral: 'tw-bg-spa-bg-tertiary tw-text-spa-primary',
      success: 'tw-bg-[color:color-mix(in_srgb,var(--spa-text-success)_12%,transparent)] tw-text-spa-success',
      warning: 'tw-bg-[color:color-mix(in_srgb,var(--spa-text-warning)_12%,transparent)] tw-text-spa-warning',
    },
  },
});

export type SPAPillTone = 'accent' | 'error' | 'info' | 'neutral' | 'success' | 'warning';

interface SPAPillProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: SPAPillTone;
}

const SPAPill = ({ className, tone, ...props }: SPAPillProps) => (
  <span className={cn(pillVariants({ tone }), className)} {...props} />
);

export default SPAPill;
